import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin(() => {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node instanceof HTMLElement) {
                    const checkForTooltip = (element: HTMLElement) => {
                        const classes = element.className?.toString() || '';
                        const role = element.getAttribute('role') || '';
                        const id = element.id || '';
                        
                        if (classes.includes('tooltip') || 
                            classes.includes('p-tooltip') ||
                            role === 'tooltip' ||
                            id.includes('tooltip')) {
                            // Add our custom classes
                            element.classList.add('p-tooltip--dark');
                            element.classList.add('p-tooltip--top');
                        }
                    };
                    
                    // Check the node itself
                    checkForTooltip(node);
                    
                    // Check all children
                    const allDescendants = node.querySelectorAll('*');
                    allDescendants.forEach((descendant) => {
                        if (descendant instanceof HTMLElement) {
                            checkForTooltip(descendant);
                        }
                    });
                }
            });
        });
    });

    // Start observing immediately
    if (document.body) {
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'role']
        });
    } else {
        // If body doesn't exist yet, wait for it
        setTimeout(() => {
            observer.observe(document.body, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['class', 'role']
            });
        }, 500);
    }
});
